export enum PepClassnames {
    "vt_empl_A" = "vt_empl_A"
}
//
export namespace PEP {
    export interface ModuleFeatures {
        useCostUnits: boolean;
        useUrlParams: boolean;
    }


    export interface WindowEx extends Window {
        PepRegistry: PEP.Registry;
        PepEmploymentEditor: any;
        InfoContainerPopup: { node: HTMLElement, cell: PEP.Cell };
        PepHome: any;
        CurrentSelectedClickMode: PEP.ClickMode;
        CurrentSelectedEmploymentTypeTemplate: PEP.EmploymentTemplate;
        DisplaySettings: PEP.LayoutSettings;
    }

        export interface AxisResponse {
            xDescriptors: Array<XAxisDescriptor>;
            yDescriptors: Array<YRowContract>;
            weekRecordData: WeekInfoDataset;
            navigationWeeks: Array<CalendarWeekNavigation>;
            base: any;
        }


        export interface AxisConfig {
            offset: number;
            base: any;
            yIDs: Array<string>;
            xIDs: Array<string>;
            colCount: number;
            stepNext: number;
            stepPrevious: number;
        }


        export type EditorData = Coordinates & {
            ID: string;
            employmentTypeID: string;
            bookingStatusID: string;
            taskDefinitionID?: string;
            costUnit1ID: string;
            costUnit2ID: string;
            costUnit3ID: string;
            start?: Date;
            end?: Date;
            is_oversteered_duration: boolean;
            is_on_duty: boolean;
            is_no_break: boolean;
            is_oversteered_time: boolean;
            startTXT?: string;
            endTXT?: string;
            pauseTXT: string;
            mainLabel: string;
            shortLabel: string;
            //notes: string;
            //note_internal_use?: string;
            is_times_confirmed: boolean;
            breaks?: Array<EmploymentBreak>;
            warningMessage?: string;
        }

    export type EmploymentData = more.EntityAPIResult & Coordinates & {
        associateID?: string;
        label?: string;
        ref_day: string;
        date?: Date;
        ref_task_definition: string;
        ref_type: string;
        ref_empl_booking_status: string;
        start: Date;
        startTXT: string;
        end: Date;
        endTXT: string;
        pauseTXT: string;
        mainLabel: string;
        shortLabel: string;
        shortLabelCompact: string;
        //mainLabelFormat: string;
        mainColorationBG: string;
        mainColorationTXT: string;
        value1: string;
        value2: string;
        duration: number;
        duration_pause: number;
        duration_payed: number;
        is_pause_payed: boolean;
        is_on_duty: boolean;
        is_no_break: boolean;
        locked: boolean;
        virtual: boolean;
        EditEmplBookingStatus: boolean;
        EditIsTimeConfirmed: boolean;
        is_times_confirmed: boolean;
        times_confirmed_by: string;
        date_time_confirmed_at: string;
        draft: boolean;
        dirty: boolean;
        deleting?: boolean;
        is_oversteered_duration: boolean;
        is_oversteered_time: boolean;
        //notes: Array<string>;
        ref_cost_unit_1: CostUnit;
        ref_cost_unit_2: CostUnit;
        ref_cost_unit_3: CostUnit;
        breaks?: Array<EmploymentBreak>;
        duration_break_minimum?: number;
        note_warnings?: string;
    }

    export interface EmploymentBreak {
        _refDate?: Date,
        startTxt: string,
        endTxt: string,
        durationMin?: number
    }

    // für die Agenda-Ansicht inkl EmploymentRevision:
    export interface EmploymentEntity extends more.EntityAPIResult {
        
        gDisp_1: string;
        date_empl_end: Date;
        time_break_1_start: Date;
        time_break_1_end: Date;
        time_break_2_start: Date;
        time_break_2_end: Date;
        time_break_3_start: Date;
        time_break_3_end: Date;
        time_break_4_start?: Date;
        time_break_4_end?: Date;
        time_break_5_start?: Date;
        time_break_5_end?: Date;
        ref_address_1: more.EntityAPIResultExtendedGDisp1;
        c_address_1: string;
        duration: number;
        duration_pause: number;

        ref_empl_type: Partial<EmploymentType>;
        ref_empl_booking_status: Partial<EmploymentBookingStatus>
    }

    export interface EmploymentRevisionEntity extends EmploymentEntity {
        _readonly: boolean;
        _readonlyMessage: string;
        _canEditTimes: boolean;
        _canEditBreaks: boolean;
    }
        export interface XAxisDescriptor {
            ID: string;
            Classname: string;
            coloration: string;
            label: string;
            //ref_day: string;
            date: string | Date;
            locked: boolean;
            specialNotes: Array<{ label: string, coloration: string, dateRange: string }>;
            weekRecordData: WeekInfoDataset;
            emplDayBaseDescription: string;
            emplDayBaseEntityViewData?: any;
            emplDayBaseNoteOfTheDay: string;
        }

        export interface CalendarWeekNavigation {
            ID: string;
            mainLabel: string;
            secondaryLabel: string;
            base: any;
            stepValue: number;
            currentWeek?: boolean;
        }

        export interface YAxisDescriptor {
            ID: string;
            coloration: string;
            colorationTXT: string;
            label: string;
            description: string;
            locked: boolean;
        }
        export interface YRowContract extends YAxisDescriptor {
            Classname: string;
            CanEditNoteInternalUse: boolean;
            bMonday: boolean;
            bTuesday: boolean;
            bWednesday: boolean;
            bThursday: boolean;
            bFriday: boolean;
            bSaturday: boolean;
            bSunday: boolean;
        }

        export interface EmploymentType {
            ID: string;
            is_active: boolean;
            description: string;
            code: string;
            mainLabel: string;
            mainLabelFormat: string;
            value1: string;
            value2: string;
            coloration: more.EntityAPIColor;
            is_calculate_work_time: boolean;
            is_calculate_time_of_performance: boolean;
            is_get_time_from_empl_contract: boolean;
            is_get_pause_from_empl_contract: boolean;
            pause_duration_default: number;
            day_counter: number;
            is_can_oversteer_time_values: boolean;
            startTXT: string;
            endTXT: string;
            pauseTXT: string;
            ref_empl_task_definiton: string;
            ref_empl_booking_status: string;
            breaks?: Array<EmploymentBreak>
        }

        export interface CostUnit {
            ID: string;
            code: string;
            gDisp?: string;
        }

        export interface EmploymentTemplate extends EmploymentType {
            costUnit1: CostUnit;
            costUnit2: CostUnit;
            costUnit3: CostUnit;
            is_on_duty: boolean;
            is_no_break: boolean;

        }

        export interface EmploymentBookingStatus {
            ID: string;
            is_active: boolean;
            description: string;
            code: string;
            symbol: string;
            coloration: more.EntityAPIColor;
        }

        export interface TaskDefinition {
            ID: string;
            is_active: boolean;
            description: string;
            code: string;
            coloration: more.EntityAPIColor;
        }

        export interface Registry {
            employmentTypes: Record<string,EmploymentType>;
            taskDefinitions: Record<string, TaskDefinition>;
            employmentBookingStatus: Record<string, EmploymentBookingStatus>;
            defaultEmploymentBookingStatus: string;
        }


    export interface Coordinates {
            xID: string;
            yID: string;
        }

    export interface CellLock extends Coordinates {
            locked: boolean;
        }

        export interface DataGrid {
            employments: Array<EmploymentData>;
            locks: Array<CellLock>;
            dayRecordInfos: Array<DayRecordInfo>;
            cellNotesData: Array<CellNotesData>;
        }

        export interface Cell {
            employmentData: EmploymentData[];
            infoData: CellInfoData;
            xID: string;
            yID: string;
            row: YRow;
            column: XCol;
            locked: boolean;
            node: HTMLDivElement;
            tableCellNode: HTMLTableCellElement;
            employmentsNode: HTMLDivElement;
            dirtyCount: number;
            employmentWidgets?: Array<any>;
            table: any;
            infoNode: HTMLElement;
            dayRecordNode: HTMLElement;
            clickEvent: any;
        }

        export interface XCol {
            descriptor: XAxisDescriptor;
            headerNode: any;
            ID: string;
            cells: Array<Cell>;
        }

        export interface YRow {
            descriptor: YRowContract;
            headerNode: HTMLDivElement;
            ID: string;
            cells: Array<Cell>;
            node: HTMLTableRowElement;
            inactive: boolean;
            //weekRecordInfoNode: PepWeekRecordElement;
        }

        export enum ClickMode {
            "default" = "default",
            "brush" = "brush",
            "brushCreate" = "brushCreate",
            "customBrush" = "customBrush",
            "delete" = "delete",
            "create" = "create",
            "brushCostUnit" = "brushCostUnit",
            "deleteCostUnit" = "deleteCostUnit",
            "cellNotes" = "cellNotes"
        }

        export interface LayoutSettings {
            smallInfo: DspSmallInfoSettings;
            mainLabel: DspMainLabelSettings;
            tableLayout: DspTableLayoutSettings;
            displayDayRecordSums: boolean;
            displayMainLabel: boolean;
            displayEmploymentValues: boolean;
            displayBookingStatus: boolean;
            displayNoteInGrid: boolean;
            //displayNoteInEditor: boolean;
            displayDayNotesInTableHeader: boolean;
            displayDayDescriptionInTableHeader: boolean;
            displaySpecialNotesInTableHeader: boolean;
            dayHeaderEntityviewLabelVariant: any;
        }

        export enum DspMainLabelSettings {
            "default" = "default",
            "costCenter" = "costCenter"
        }

        export enum DspSmallInfoSettings {

            "values" = "values",
            "bookingStatus" = "bookingStatus"
        }

        export enum DspTableLayoutSettings {
            "default" = "default",
            "compact" = "compact"
        }

        export enum SubmitEntryMode {
            "delete" = 0, // 0
            "change" = 1, // 1
            "create" = 2 // 2
        }

        export interface ResultData {
            //ID: string;
            editedData: EditorData;
            mode: SubmitEntryMode;
            //node: HTMLElement;
            //originalEntry: PepEmploymentData;
        }

       
        export interface SaveEmploymentsResponse {
            employments: Array<EmploymentData>;
            dayRecordInfos: Array<DayRecordInfo>;
            cellNotesData: Array<CellNotesData>;
            deleted: Array<string>;
            created: Array<string>;
            modified: Array<string>;
            weekRecordData: WeekInfoDataset;
            errorMessage?: string;
            warnings?: Array<string>;
            locks: Array<CellLock>;
            xDescriptorUpdates?: Array<XAxisDescriptor>;
            yDescriptorUpdates?: Array<YAxisDescriptor>;
        }

    export interface DayRecordInfo extends Coordinates {
            dayRecordID?: string;
            Classname?: string;
            notes: Array<string>;
            note_internal_use?: string;
            CanEditNoteInternalUse?: boolean;
            columns: Array<{
                name: string;
                value: string;
                label: string;
                tooltip: string;
                colorationTXT: string;
                colorationBG: string;
                grow: number;
            }>;
    }
    export interface CellInfoData extends Coordinates {
        cellNotes?: Array<PEP.CellNotesData>
        dayRecordInfo: PEP.DayRecordInfo
    }

        export interface DayRecordSaveData extends Coordinates {
            // alles was im PepCellInfo-Popup verändert und zurückgespeichert werden kann
            note: string;
            note_internal: string;
            dayRecordID: string;

            
    }

    


    export interface CellNotesData extends Coordinates {
        entityID?: string;
        Classname?: string;
        title: string;
        infotext: string;
        icon?: string;
        color?: more.EntityAPIColor;
        warningLevel?: 0 | 1 | 2;
    }


        export interface WeekRecordElement {
            data: WeekInfoData;
            node: HTMLElement;
        }

        export interface WeekInfoDataset {
            ID: string;
            labelA: string;
            labelB: string;
            weekRecordDataA: {
                columnCount: number;
                entries: Array<WeekInfoData>;
            }
            weekRecordDataB: {
                columnCount: number;

                entries: Array<WeekInfoData>;
            }
        }

        export interface WeekInfoData {
            yID: string;
            lines: Array<{
                name: string;
                value: string;
                label: string;
                tooltip: string;
                colorationTXT: string;
                colorationBG: string;
                targetColumn: number;
            }>;
    }


        export enum UrlParameter {
            "calendarWeek" = "cw",
            "contractDispGroup" = "ctr",
            "contractByName" = "name",
            "targetID" = "trg",
            "targetType" = "trty",
            "displayCompactMode" = "dspC",
            "displayEmploymentValues" = "dspV",
            "displaySpecialNotesInHeader" = "dspSN",
            "displayDayNotesInHeader" = "dspDN",
            "displayDayDescriptionInHeader" = "dspDD"
        }
    }